import LunchPreviewSection from "./section/LunchPreviewSection";
import { formatDayOfWeek, formatTime } from "../../../../utils/date";
import './LunchPreview.scss';
import PropTypes from "prop-types";

const formatDishValues = (values) => values.map(value => `- ${value}`).join('\n');
const formatDishOption = ({title, values}) => `${title}:\n${formatDishValues(values)}`;
const formatDishOptions = (options = []) => options.map(formatDishOption).join('\n');
const formatDishDescription = (description, options) => `${description}\n${formatDishOptions(options)}`;

const LunchPreview = ({title, description, dishes, company, companyUrl, endDate}) => {
    const endTime = formatTime(endDate);
    const weekDay = formatDayOfWeek(endDate);
    return (
        <div className="lunch-preview">
            <div>New lunch menu alert!</div>
            <LunchPreviewSection title={title} text={description}/>
            {dishes.map(({name, description, options}) => (
                <LunchPreviewSection title={name} text={formatDishDescription(description, options)}/>
            ))}
            <LunchPreviewSection title={company} text={companyUrl}/>
            <LunchPreviewSection text={`Closes at ${endTime} on ${weekDay}.`}/>
        </div>
    );
};

LunchPreview.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    dishes: PropTypes.array,
    company: PropTypes.string,
    companyUrl: PropTypes.string,
    endDate: PropTypes.object.isRequired
}

export default LunchPreview;
